import { RootState } from "../../../redux-store";

export const selectFormData = (state: RootState) =>
  state.app.teamsDialog.formData;
